import { Platform, StyleSheet } from 'react-native'
import styled from 'styled-components/native'
import { Fonts, Colors, Metrics } from 'APP/Themes'

export const MAX_WIDTH_MOBILE = 175
export const MAX_WIDTH_DEFAULT = 392

export const MAX_SERVICE_WIDTH_MOBILE = 328
export const MAX_SERVICE_WIDTH_DEFAULT = 392

export const MAX_WIDTH = Platform.select({
  ios: MAX_WIDTH_MOBILE,
  android: MAX_WIDTH_MOBILE,
  native: MAX_WIDTH_DEFAULT,
  default: MAX_WIDTH_DEFAULT,
})

export const MAX_SERVICE_WIDTH = Platform.select({
  ios: MAX_SERVICE_WIDTH_MOBILE,
  android: MAX_SERVICE_WIDTH_MOBILE,
  native: MAX_SERVICE_WIDTH_DEFAULT,
  default: MAX_SERVICE_WIDTH_DEFAULT,
})

export const LIST_ITEM_MARGIN = Metrics.baseMargin * 0.75

export const StyledHeaderContainer = styled.View`
  flex-direction: row;
  align-items: center;
  margin-top: ${({ theme }) => theme.metrics.baseMargin}px;
  margin-left: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  margin-right: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
`

export default StyleSheet.create({
  copy: {
    ...Fonts.style.bodySmall,
    color: Colors.text,
  },
  altCopy: {
    textTransform: 'capitalize',
    paddingLeft: Metrics.baseMargin * 0.6,
  },
  sectionTitle: {
    flex: 1,
  },
  list: {
    paddingHorizontal: Metrics.baseMargin * 0.75,
  },
})
